/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { ErrorPayload } from '@src/types';
import { ChannelMap } from '@src/types/channels';

type RequestStatus = 'idle' | 'pending' | 'success' | 'failure' | 'fulfill';

type ChannelsState = {
  request: {
    status: RequestStatus;
    error?: ErrorPayload;
  };
  data: {
    channels: ChannelMap;
    count: number;
  };
};

const initialState: ChannelsState = {
  request: {
    status: 'idle',
    error: undefined,
  },
  data: {
    channels: [],
    count: 0,
  },
};

const channelsSlice = createSlice({
  name: 'channelsSlice',
  initialState,
  reducers: {
    fetchChannels(state, action: PayloadAction<number[] | undefined>) {
      state.request.status = 'pending';
      state.request.error = undefined;

      Object.keys(state.data.channels).forEach(id => {
        if (!action.payload?.includes(+id)) {
          delete state.data.channels[+id];
        }
      });
      state.data.count = Object.keys(state.data.channels)?.length;
    },
    fetchChannelsSuccess(state, action: PayloadAction<ChannelMap>) {
      state.request.status = 'success';
      state.data.channels = action.payload;
      state.data.count = Object.keys(state.data.channels)?.length;
    },
    fetchChannelsFailure(state, action: PayloadAction<ErrorPayload>) {
      state.request.status = 'failure';
      state.request.error = action.payload;
    },
    fetchChannelsFulfill(state) {
      state.request.status = 'fulfill';
    },
    resetChannelsState() {
      return initialState;
    },
  },
});

export default channelsSlice.reducer;

export const {
  fetchChannels,
  fetchChannelsSuccess,
  fetchChannelsFailure,
  fetchChannelsFulfill,
  resetChannelsState,
} = channelsSlice.actions;

export const channelsActions = channelsSlice.actions;
